<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-cubes mr-2" />Inventory</h5>
            <hr />
            <b-row>
                <b-col md="8">
                    <div class="d-flex">
                        <b-input-group>
                            <b-input-group-prepend>
                                <b-button variant="dark" @click="showModalFilter">
                                    <i class="fa fa-search mr-2" />Filter...
                                </b-button>
                            </b-input-group-prepend>
                            <b-form-input v-model="filter.noFaktur" maxlength="50" placeholder="Cari No. Faktur..."
                                @keydown.enter="changeFilter()" />

                        </b-input-group>
                        <b-input-group class="ml-2">
                            <b-form-input v-model="filter.imeiSn" maxlength="50" placeholder="Cari No. Imei..."
                                @keydown.enter="changeFilter()" />
                            <b-input-group-append>
                                <b-button variant="primary" @click="changeFilter()">Cari</b-button>
                            </b-input-group-append>
                        </b-input-group>
                        <b-button class="ml-2" variant="danger" @click="resetFilter">
                            Reset
                        </b-button>
                    </div>
                </b-col>
                <b-col md="4" class="text-right">
                    <b-button v-if="isDownloadExcelAllowed" variant="success" @click="downloadExcelStock">
                        <i class="fa fa-download mr-2" />Download Excel Stock
                    </b-button>
                </b-col>
            </b-row>
            <template v-if="initTable">
                <b-table bordered hover show-empty no-local-sorting :busy="isBusy" :items="items" :fields="fields"
                    @sort-changed="onSortChanged" responsive class="my-3">
                    <template v-slot:empty>
                        Tidak ada data inventory.
                    </template>
                    <template v-slot:cell(item)="row">
                        {{ row.item.type }} <span v-if="row.item.item_year != null">({{ row.item.item_year }})</span>
                        <div class="small" v-if="row.item.color_id != null">
                            {{ row.item.kind }} - {{ row.item.brand }} - {{ row.item.color }}<br />
                            NF <strong style="cursor:pointer;" @click="copyToClipboard(row.item.no_faktur_pgi)">{{ row.item.no_faktur_pgi }}</strong> <i style="cursor:pointer;" @click="copyToClipboard(row.item.no_faktur_pgi)" class="fa fa-fw fa-copy" /><br />
                            IMEI <strong style="cursor:pointer;" @click="copyToClipboard(row.item.imei_sn)">{{ row.item.imei_sn }} </strong> <i style="cursor:pointer;"   @click="copyToClipboard(row.item.imei_sn)" class="fa fa-fw fa-copy" />
                        </div>
                        <div class="small" v-else>
                            {{ row.item.kind }} - {{ row.item.brand }}<br />
                            NF <strong>{{ row.item.no_faktur_pgi }}</strong><br />
                            IMEI {{ row.item.imei_sn }}
                        </div>
                    </template>
                    <template v-slot:cell(price)="row">
                        <!-- Rp. {{ $helper.formatThousand(row.item.final_price) }} -->
                        <!-- Rp. {{ $helper.formatThousand(row.item.final_price_after_adj) }} -->
                        Rp. {{ $helper.formatThousand(row.item.final_price_after_segment) }}
                        <div class="small">
                            Harga Dasar: Rp. {{ $helper.formatThousand(row.item.base_price) }}<br />
                            Kloter {{ $helper.parseDate(row.item.created) }}<br />
                            {{ row.item.source || "-" }}
                        </div>
                    </template>
                    <template v-slot:cell(detail)="row">
                        Grade <strong>{{ row.item.grade }}</strong>
                        <div class="small">
                            <div v-if="row.item.item_spec_id == 2 && row.item.is_handphone == 0">
                                Spek <strong>ORI</strong><br />
                            </div>
                            <div v-else>
                                Spek <strong>{{ row.item.spec }}</strong><br />
                            </div>
                            {{ row.item.is_batangan == true ? "Batangan" : "Lengkap" }}<br />
                            {{ row.item.warehouse == null ? "-" : "Gudang " + row.item.warehouse }} - {{ row.item.office
                            }}
                        </div>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge :variant="parseStatus(row.item.status, 0)">{{ parseStatus(row.item.status, 1)
                            }}</b-badge>
                    </template>
                    <template v-slot:cell(action)="row">
                        <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail"
                            @click="showDetail(row.item)">
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                        <b-button size="sm" class="ml-2" variant="dark" v-b-tooltip.hover.top title="Gambar Fisik"
                            :disabled="isSubmitting" @click="prepareImage(row.item, 'fisik')">
                            <i class="fa fa-fw fa-picture-o" />
                        </b-button>
                        <b-button size="sm" class="ml-2" variant="dark" v-b-tooltip.hover.top title="Gambar Kerusakan"
                            :disabled="isSubmitting" @click="prepareImage(row.item, 'kerusakan')">
                            <i class="fa fa-fw fa-picture-o" />
                        </b-button>
                        <b-button size="sm" v-if="isAdjustAllowed(row.item)" class="ml-2" variant="dark"
                            v-b-tooltip.hover.top title="Adjustment Barang" :disabled="isSubmitting"
                            @click="prepareAdjustment(row.item)">
                            <i class="fa fa-fw fa-wrench" />
                        </b-button>
                        <b-button size="sm" class="ml-2" variant="dark" v-b-tooltip.hover.top title="Update Warna"
                            :disabled="isSubmitting" @click="prepareColorUpdate(row.item)">
                            <i class="fa fa-fw fa-paint-brush" />
                        </b-button>
                        <b-button size="sm" v-if="isPrintAllowed(row.item)" class="ml-2" variant="dark"
                            v-b-tooltip.hover.top title="Print Barcode" @click="prepareReprint(row.item.id)">
                            <i class="fa fa-fw fa-print" />
                        </b-button>
                        <b-button size="sm" v-if="isMoveInventoryAllowed && isMoveAllowed(row.item)" class="ml-2"
                            variant="warning" v-b-tooltip.hover.top title="Pindah Gudang"
                            @click="prepareMove(row.item)">
                            <i class="fa fa-fw fa-truck" />
                        </b-button>
                        <b-button size="sm" v-if="isRequestResetAllowed && isResetAllowed(row.item)" class="ml-2"
                            variant="danger" v-b-tooltip.hover.top title="Reset Grade"
                            @click="prepareReset(row.item, 'Grade')">
                            <i class="fa fa-fw fa-pencil" />
                        </b-button>
                        <b-button size="sm" v-if="isRequestResetAllowed && isResetAllowed(row.item)" class="ml-2"
                            variant="danger" v-b-tooltip.hover.top title="Reset Data" @click="prepareReset(row.item)">
                            <i class="fa fa-fw fa-refresh" />
                        </b-button>
                    </template>
                    <template #table-busy>
                        <div class="d-flex justify-content-center">
                            <b-spinner label="Loading..." />
                        </div>
                    </template>
                </b-table>
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange"
                    @page-change="onPageChange" />
            </template>
            <div class="d-flex justify-content-center mt-3">
                <b-spinner v-if="isLoadingTable && !initTable" label="Loading..." />
            </div>
        </b-card>
        <b-modal id="m-detail" title="Detail Inventory" size="lg" no-close-on-backdrop no-close-on-esc hide-footer>
            <DetailInventory :id="activeId" />
        </b-modal>
        <b-modal id="m-reprint-code" title="Reprint Barcode" centered no-close-on-backdrop hide-footer
            @shown="$refs.passcode.focus()">
            <b-form-group label="Passcode Reprint">
                <b-form-input type="password" ref="passcode" maxlength="10" v-model="passcode"
                    @keydown.enter="getReprintBarcode" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="getReprintBarcode">
                    {{ isSubmitting ? "Mengambil..." : "Reprint" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-reprint-barcode" title="Reprint Barcode" no-close-on-backdrop no-close-on-esc hide-footer
            hide-header-close>
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeType">
                            Print {{ barcodeType == 'barcode' ? 'Kerusakan' : 'Barcode' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="$bvModal.hide('m-reprint-barcode')">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal id="m-move" title="Pindah Gudang" no-close-on-backdrop no-close-on-esc hide-footer>
            {{ activeItem.type }} - NF {{ activeItem.no_faktur_pgi }}<br /><br />
            <b-form-group label="Pindahkan ke...">
                <b-form-select v-model="input.warehouse" :options="optWarehouse" text-field="name" value-field="id">
                    <template #first>
                        <b-form-select-option value=0 disabled>Pilih Gudang...</b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="promptMove">
                    {{ isSubmitting ? "Memindahkan..." : "Pindahkan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-request-reset" :title="'Request Reset ' + resetType" no-close-on-backdrop no-close-on-esc
            hide-footer>
            Menyiapkan request reset {{ resetType.toLowerCase() }} untuk NF {{ activeItem.no_faktur_pgi }}<br /><br />
            <b-form-group label="Keterangan">
                <b-input v-model="resetReason" maxlength="200" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="promptReset">
                    {{ isSubmitting ? "Menyimpan..." : "Request Reset" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-barcode" title="Cetak Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer
            hide-header-close>
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe :src="getBarcodeMoveLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeMoveType">
                            Print {{ barcodeMoveType == 'barcode' ? 'Kerusakan' : 'Barcode' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="$bvModal.hide('m-barcode')">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal id="m-filter" title="Filter Pencarian" size="lg" no-close-on-backdrop no-close-on-esc hide-footer>
            <strong>DATA BARANG</strong>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Nama Barang">
                        <b-form-input v-model="filter.name" maxlength="50" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Jenis">
                        <multiselect v-model="filter.kind" label="name" track-by="id" :internal-search="true"
                            deselect-label="" select-label="" :options="optKind" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Merk">
                        <multiselect v-model="filter.brand" label="name" track-by="id" :internal-search="true"
                            deselect-label="" select-label="" :options="optBrand" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <b-form-group label="Tahun / Generasi Barang">
                        <b-form-input v-model="filter.itemYear" maxlength="4" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="No. Faktur PGI">
                        <b-form-input v-model="filter.noFaktur" maxlength="50" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="IMEI / SN">
                        <b-form-input v-model="filter.imeiSn" maxlength="100" />
                    </b-form-group>
                </b-col>
            </b-row>
            <hr />
            <strong>PENILAIAN DAN STATUS BARANG</strong>
            <b-row class="mt-1">
                <b-col md="6">
                    <b-form-group label="Status">
                        <multiselect :multiple="true" :close-on-select="false" v-model="filter.status" label="name"
                            track-by="id" :internal-search="true" deselect-label="" select-label=""
                            :options="optStatus" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Grade">
                        <multiselect :multiple="true" :close-on-select="false" v-model="filter.grade" label="name"
                            track-by="id" :internal-search="true" deselect-label="" select-label=""
                            :options="optGrade" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <b-form-group label="Kelengkapan">
                        <b-form-select v-model="filter.isBatangan" :options="optIsBatangan" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Gudang">
                        <multiselect v-model="filter.warehouse" label="name" track-by="id" :internal-search="true"
                            deselect-label="" select-label="" :options="optWarehouse" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Spek">
                        <multiselect v-model="filter.spec" label="name" track-by="id" :internal-search="true"
                            deselect-label="" select-label="" :options="optSpec" />
                    </b-form-group>
                </b-col>
            </b-row>
            <hr />
            <strong>KLOTER PENGIRIMAN</strong>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Dari">
                        <b-form-input type="date" v-model="filter.from" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Sampai">
                        <b-form-input type="date" v-model="filter.to" />
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="mt-4 text-right">
                <b-button variant="danger" @click="resetFilter">
                    Reset Filter
                </b-button>
                <b-button variant="primary" class="ml-3" @click="getItems()">
                    Cari
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-download-report" title="Download Excel Stock" centered no-close-on-backdrop no-close-on-esc
            hide-footer>
            <div v-if="fetchReportStatus == 0">Menyiapkan laporan, mohon menunggu...</div>
            <div v-else-if="fetchReportStatus == -1">Gagal mendapatkan laporan, mohon coba kembali!</div>
            <div v-else>
                Silahkan tekan tombol dibawah ini untuk download laporan.
                <div class="mt-2">
                    <a :href="$BASE_FILE_PATH + reportPath" download>
                        <b-button variant="success">
                            <i class="fa fa-download mr-2" />Download
                        </b-button>
                    </a>
                </div>
            </div>
        </b-modal>
        <b-modal id="m-image-old" :title="'Edit Gambar Fisik Item ' + activeItem.type" size="xl"
            @close="onCloseModalImage" no-close-on-backdrop no-close-on-esc hide-footer>
            <!-- Menyiapkan request reset {{ resetType.toLowerCase() }} untuk NF {{ activeItem.no_faktur_pgi }}<br /><br />
            <b-form-group label="Keterangan">
                <b-input v-model="resetReason" maxlength="200" />
            </b-form-group> -->
            <b-row>
                <b-col cols="12" lg="8">
                    <div class="media-container">
                        <b-img-lazy v-if="mediaPreview.media == 'image'" class="media-preview"
                            :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.urlCompress"
                            blank-src="image-loading.gif" block alt="Image Preview"></b-img-lazy>
                        <video v-else-if="mediaPreview.media == 'video'" class="media-preview" controls
                            :key="mediaPreview.url">
                            <source v-if="mediaPreview.type == 'video/webm'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/ogg'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/mp4'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/3gpp'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <!-- <source v-else :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url" :type="mediaPreview.type"> -->
                            Your browser does not support the video tag.
                        </video>
                        <b-img-lazy v-else class="media-preview" src="/img/img-preview.png" block
                            alt="No Image"></b-img-lazy>
                    </div>
                    <div v-if="mediaPreview.title" class="d-flex justify-content-center my-3">
                        <h4>{{ mediaPreview.title || "-" }}</h4>
                    </div>
                    <div class="media-scroll">
                        <div class="media-scroll-content" v-for="(media, index) in filterMediaList" :key="'ms-' + index"
                            @click="onClickImage(media.urlCompress)">
                            <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }"
                                :src="media.media == 'video' ? '/img/video-thumbnail.png' : media.status == 'upload' ? media.url : $BASE_FILE_PATH + media.urlCompress"
                                blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy>
                            <!-- <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }" src="https://sample-videos.com/img/Sample-png-image-5mb.png" blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy> -->
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="4" class="border-responsive">
                    <!-- <b-button block variant="success"
                        :disabled="filterMediaList.length >= 10 || isSubmitting || prepareImageType == 'kerusakan' || activeItem.is_public"
                        @click="onAddImage">

                        {{ isSubmitting ? "Menyimpan..." : "Upload Item Gambar Baru" }}
                    </b-button> -->
                    <b-button block variant="primary"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting"
                        @click="onOpenImage(mediaPreview.url)">
                        {{ isSubmitting ? "Menyimpan..." : "Tampilkan Item di Tab Baru" }}
                    </b-button>
                    <!-- <b-button block variant="danger"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting || prepareImageType == 'kerusakan' || activeItem.is_public"
                        @click="onDeleteImage(mediaPreview.url)">

                        {{ isSubmitting ? "Menyimpan..." : "Hapus Item" }}
                    </b-button> -->
                    <div class="mt-3 media-disclaimer" v-if="prepareImageType == 'kerusakan'">
                        <small>*Menu ini sudah tidak dapat digunakan untuk upload / delete gambar. Mohon menggunakan
                            menu gambar
                            pada adjustment barang.</small><br>
                        <!-- <small>*Jenis item gambar yang dapat diterima oleh sistem adalah format JPG, JPEG, dan PNG.</small><br> -->
                        <!-- <small>*Jenis item video yang dapat diterima oleh sistem adalah format MP4, OGG, dan WEBM.</small><br> -->
                        <!-- <small>*Maksimal ukuran gambar / video yang dapat diterima oleh sistem sebesar 1MB.</small><br> -->
                        <!-- <small>*Minimal jumlah item gambar / video per inventori sebanyak 3 buah item.</small><br> -->
                        <!-- <small>*Maksimal jumlah item gambar / video per inventori sebanyak 8 buah item.</small> -->
                    </div>
                    <div class="mt-3 media-disclaimer" v-else>
                        <small>*Jenis item gambar yang dapat diterima oleh sistem adalah format JPG, JPEG, dan
                            PNG.</small><br>
                        <small>*Maksimal ukuran total gambar untuk sekali upload sebesar 400MB.</small><br>
                        <small>*Minimal jumlah item gambar per inventori sebanyak 1 buah item.</small><br>
                        <small>*Maksimal jumlah item gambar per inventori sebanyak 10 buah item.</small>
                    </div>
                </b-col>
            </b-row>
            <div class="mt-4 text-right">
                <b-button variant="secondary" class="mr-2" :disabled="isSubmitting"
                    @click="$bvModal.hide('m-image-old')">
                    Batal
                </b-button>
                <!-- <b-button variant="primary" :disabled="isSubmitting || activeItem.is_public"
                    @click="onSaveImageFisik(activeItem.id)">

                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button> -->
            </div>
            <input multiple style="opacity: 0; filter:alpha(opacity=0);" ref="fileupload" type="file"
                @change="onUploadImage" accept="image/png, image/jpeg">
        </b-modal>
        <b-modal id="m-image"
            :title="'Edit Gambar Kerusakan Item ' + activeItem.type + ' (' + activeAdjustment.name + ')'" size="xl"
            @close="onCloseModalImage" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row>
                <b-col cols="12" lg="8">
                    <div class="media-container">
                        <b-img-lazy v-if="mediaPreview.media == 'image'" class="media-preview"
                            :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                            blank-src="image-loading.gif" block alt="Image Preview"></b-img-lazy>
                        <video v-else-if="mediaPreview.media == 'video'" class="media-preview" controls
                            :key="mediaPreview.url">
                            <source v-if="mediaPreview.type == 'video/webm'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/ogg'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/mp4'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/3gpp'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <!-- <source v-else :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url" :type="mediaPreview.type"> -->
                            Your browser does not support the video tag.
                        </video>
                        <b-img-lazy v-else class="media-preview" src="/img/img-preview.png" block
                            alt="No Image"></b-img-lazy>
                    </div>
                    <div class="media-scroll">
                        <div class="media-scroll-content" v-for="(media, index) in filterMediaList" :key="'ms-' + index"
                            @click="onClickImage(media.urlCompress)">
                            <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }"
                                :src="media.media == 'video' ? '/img/video-thumbnail.png' : media.status == 'upload' ? media.url : $BASE_FILE_PATH + media.urlCompress"
                                blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy>
                            <!-- <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }" src="https://sample-videos.com/img/Sample-png-image-5mb.png" blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy> -->
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="4" class="border-responsive">
                    <!-- <b-button block variant="success" :disabled="filterMediaList.length >= 10 || isSubmitting"
                        @click="onAddImage">
                        {{ isSubmitting ? "Menyimpan..." : "Upload Item Gambar / Video Baru" }}
                    </b-button> -->

                    <b-button block variant="warning" class="mb-2" @click="onRefreshImage()">
                        Refresh
                    </b-button>

                    <span v-show="!isUpload" id="uploadFile" class="my-2">
                        <b-button block variant="success">
                            {{ isSubmitting ? "Menyimpan..." : "Upload Item Gambar / Video Baru" }}
                        </b-button>
                    </span>

                    <div :key="uploadKey">
                        <div v-for="item in fileUploadResumable" :key="item.uniqueIdentifier">
                            <div v-if="item && item.status == 'uploading'">{{ item.fileName || "" }}
                                <uploading style="width:100%" :completedSteps="item.progress" />
                            </div>

                            <div v-if="item && item.status == 'retry'" class="text-center">
                                Sedang menghubungkan kembali, mohon menunggu...
                            </div>

                            <div v-if="item && item.status == 'error'" class="text-center">
                                Mengalami kesalahan, silahkan coba lagi.
                            </div>
                        </div>

                        <div v-if="finalizeBroken" class="text-center">Sedang proses finalisasi, mohon menunggu...</div>
                    </div>

                    <b-button block variant="primary" class="mt-2"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting"
                        @click="onOpenImage(mediaPreview.url)">
                        {{ isSubmitting ? "Menyimpan..." : "Tampilkan Item di Tab Baru" }}
                    </b-button>
                    <b-button block variant="danger"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting"
                        @click="onDeleteImage(mediaPreview.url)">
                        {{ isSubmitting ? "Menyimpan..." : "Hapus Item" }}
                    </b-button>
                    <div class="mt-3 media-disclaimer">
                        <small>*Jenis item gambar yang dapat diterima oleh sistem adalah format JPG, JPEG, dan
                            PNG.</small><br>
                        <small>*Jenis item video yang dapat diterima oleh sistem adalah format MP4, OGG, dan
                            WEBM.</small><br>
                        <small>*Maksimal ukuran total gambar / video untuk sekali upload sebesar 400MB.</small><br>
                        <small>*Minimal jumlah item gambar / video per inventori sebanyak 1 buah item.</small><br>
                        <small>*Maksimal jumlah item gambar / video per inventori sebanyak 10 buah item.</small>
                    </div>
                </b-col>
            </b-row>
            <!-- <div class="mt-4 text-right">
                <b-button variant="secondary" class="mr-2" :disabled="isSubmitting" @click="$bvModal.hide('m-image')">
                    Batal
                </b-button>
                <b-button variant="primary" :disabled="isSubmitting" @click="onSaveImage">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div> -->
            <input multiple style="opacity: 0; filter:alpha(opacity=0);" ref="fileupload" type="file"
                @change="onUploadImage" accept="image/png, image/jpeg, video/mp4, video/webm, video/ogg">
        </b-modal>
        <b-modal id="m-item-to-adjust" title="Adjustment Barang Masuk" size="xl" @close="onCloseModalAdjustment"
            centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div>
                <b-table bordered hover show-empty no-local-sorting :items="invoiceAdjustments" :fields="fieldsAdjust"
                    responsive class="my-4">
                    <template v-slot:empty>
                        Tidak ada adjustment.
                    </template>
                    <template v-slot:cell(category)="row">
                        <!-- <b-form-input v-model="row.item.name" maxlength="50" /> -->
                        <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                        <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="optAdjustments" @change="onChangeAdjustmentSelect($event, row.index)" /> -->
                        <b-form-select v-model="row.item.category" :options="optCategory"
                            @change="onChangeRowCategory(row.index)"
                            :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment)" />
                    </template>
                    <template v-slot:cell(name)="row">
                        <!-- <b-form-input v-model="row.item.name" maxlength="50" /> -->
                        <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                        <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="optAdjustments" @change="onChangeAdjustmentSelect($event, row.index)" /> -->
                        <b-form-select v-model="row.item.adjustmentSelect" :options="row.item.optAdjustments"
                            @change="changeAdjustment"
                            :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment)" />
                        <small class="text-muted"
                            v-if="row.item.adjustmentSelect === null || row.item.adjustmentSelect.id == null">{{
            row.item.name_placeholder }}</small>
                    </template>
                    <template v-slot:cell(adjustment)="row">
                        <b-input-group prepend="Rp.">
                            <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                            <!-- <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)" disabled></b-form-input> -->
                            <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)"
                                :disabled="(row.item.adjustmentPercentage != '' && row.item.adjustmentPercentage != null) || activeItem.status == '3'"></b-form-input>
                        </b-input-group>
                    </template>
                    <template v-slot:cell(adjustmentPercent)="row">
                        <b-input-group append="%">
                            <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                            <!-- <b-form-input v-model="row.item.adjustmentPercentage" disabled></b-form-input> -->
                            <b-form-input v-model="row.item.adjustmentPercentage" @input="changeAdjustment"
                                :disabled="(row.item.adjustment != '' && row.item.adjustment != null) || activeItem.status == '3'"></b-form-input>
                        </b-input-group>
                    </template>
                    <template v-slot:cell(action)="row">
                        <div class="d-flex">
                            <b-button size="sm" variant="dark" v-b-tooltip.hover.top title="Gambar Kerusakan"
                                :disabled="$helper.isBlank(row.item.adjustmentSelect) || isSubmitting"
                                @click="prepareAdjImage(row.item)">
                                <i class="fa fa-fw fa-picture-o" />
                            </b-button>
                            <b-button variant="danger" size="sm" class="ml-2" v-b-tooltip.hover.top title="Hapus"
                                :disabled="activeItem.status == '3' || activeItem.is_public"
                                @click="deleteRow(row.index)">
                                <i class="fa fa-fw fa-times" />
                            </b-button>
                        </div>
                    </template>
                </b-table>
                <b-row>
                    <b-col md="6">
                        <!-- <b-button variant="dark" @click="addRow" :disabled="isSubmitting"> -->
                        <b-button variant="dark" @click="prepareAddAdjustment"
                            :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment) || isSubmitting || activeItem.is_public">
                            <i class="fa fa-plus mr-2" />Tambah Keterangan
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="confirmAdd(activeItem.id)"
                            :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment) || isSubmitting || activeItem.is_public">
                            <i class="fa fa-check mr-2" />Simpan
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal id="m-add-adjustment" title="Tambah Adjustment" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Jenis Barang">
                <b-form-select v-model="addAdj.kind" :options="addAdj.optKind" disabled />
            </b-form-group>
            <b-form-group label="Kategori Kerusakan">
                <b-form-select v-model="addAdj.category" :options="optCategory" @input="onChangeAdjCategory" />
            </b-form-group>
            <b-form-group label="Keterangan">
                <b-form-select v-model="addAdj.name" :options="addAdj.optAdjustments"
                    :disabled="$helper.isBlank(addAdj.category) || addAdj.optAdjustments.length <= 0" />
            </b-form-group>
            <b-form-group label="Adjustment Harga (Nominal)">
                <b-input-group prepend="Rp.">
                    <b-form-input v-model="addAdj.adjustment" @input="sanitize(addAdj)"
                        :disabled="$helper.isBlank(addAdj.name) || addAdj.adjustmentPercentage != '' || activeItem.fixing_adjustment == 1"
                        maxlength="50" />
                </b-input-group>
            </b-form-group>
            <b-form-group label="Adjustment Harga (Persentase)">
                <b-input-group append="%">
                    <b-form-input v-model="addAdj.adjustmentPercentage"
                        :disabled="$helper.isBlank(addAdj.name) || addAdj.adjustment != '' || activeItem.fixing_adjustment == 1"
                        maxlength="50" />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmAddAdjustment">
                    {{ isSubmitting ? "Menambah..." : "Tambah" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-update-color" title="Update Warna Barang" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Warna Barang">
                <multiselect v-model="inputColor" label="name" track-by="id" :internal-search="true" deselect-label=""
                    select-label="" :options="optColor" placeholder="Pilih Warna" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting || activeItem.is_public"
                    @click="confirmUpdateColor">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import DetailInventory from './DetailInventory.vue'
import lodash from 'lodash'
import Resumable from 'resumablejs';
import Uploading from './Uploading.vue'

export default {
    components: {
        DetailInventory,
        Uploading
    },
    data() {
        return {

            initStatus: 0,
            initTable: 0,
            isLoadingTable: false,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            isDownloadExcelAllowed: false,
            isMoveInventoryAllowed: false,
            isRequestResetAllowed: false,

            fetchReportStatus: 0,
            reportPath: "",

            activeId: 0,
            passcode: "",
            resetReason: "",
            resetType: "",

            filter: {
                name: "",
                kind: null,
                brand: null,
                itemYear: "",
                spec: null,
                warehouse: null,
                noFaktur: "",
                imeiSn: "",
                grade: [],
                isBatangan: -1,
                status: [],
                from: null,
                to: null
            },

            input: {
                warehouse: 0,
            },

            inputColor: {},

            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],

            fields: [
                { key: "item", label: "Barang", sortable: true },
                { key: "price", label: "Harga Jual", sortable: true },
                { key: "detail", label: "Detail", sortable: true },
                { key: "status", label: "Status", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            fieldsAdjust: [
                { key: "category", label: "Kategori", sortable: false, thClass: 'adjust-column-min' },
                { key: "name", label: "Keterangan", sortable: false, thClass: 'adjust-column-min' },
                { key: "adjustment", label: "Potongan / Tambahan Harga (Nominal)", sortable: false },
                { key: "adjustmentPercent", label: "Potongan / Tambahan Harga (Persen)", sortable: false },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optKind: [],
            optBrand: [],
            optSpec: [],
            optWarehouse: [],
            optColor: [],

            optGrade: [
                { id: "S", name: "S" },
                { id: "A", name: "A" },
                { id: "B", name: "B" },
                { id: "C", name: "C" },
                { id: "X", name: "X" },
            ],
            optIsBatangan: [
                { value: -1, text: "Semua" },
                { value: 1, text: "Batangan" },
                { value: 0, text: "Lengkap" }
            ],
            optStatus: [
                // { value: -1, text: "Semua" },
                { id: 2, name: "READY" },
                { id: 7, name: "DRAFT" },
                { id: 3, name: "TERJUAL" },
                { id: 4, name: "RETUR" },
                { id: 5, name: "HILANG" },
                { id: 55, name: "REQUEST HILANG" },
                { id: 6, name: "KIRIM BALIK PGI" },
                { id: 66, name: "REQUEST KIRIM BALIK" },
                { id: 8, name: "REQUEST RESET" },
                { id: 9, name: "REQUEST MOVE" }
            ],

            mediaPreview: {},

            mediaList: [],

            isImageChanged: false,

            invoiceAdjustments: [],

            optAdjustments: [],

            optCategory: [],

            addAdj: {
                kind: null,
                optKind: [],
                category: null,
                name: null,
                optAdjustments: [],
                adjustment: "",
                adjustmentPercentage: ""
            },

            activeAdjustment: {},

            isChangeAdjustment: false,
            isChangePhotoAdjustment: false,

            prepareImageType: "",

            barcodeLink: "",
            barcodeLinkDamage: "",
            barcodeMoveLink: "",
            barcodeMoveLinkDamage: "",

            barcodeType: 'barcode',
            barcodeMoveType: 'barcode',
            barcodeToggleCooldown: false,

            fileUploadResumable: [],
            resumable: false,
            uploadKey: 0,
            isUpload: false,

            activeAdjustmentRow: "",
            finalizeBroken: false,
        }
    },

    watch: {

        "filter.kind": function (newVal) {

            this.filter.brand = null
            this.optBrand = []

            if (newVal != null) {

                this.$axios.get("master/brands/" + this.filter.kind.id).then(res => {
                    this.optBrand = res.data.data
                })

            }

        }

    },

    methods: {

        init() {

            this.initStatus = 0
            // let getItems = this.getItems()

            let getKinds = this.$axios.get("master/kinds").then(res => {
                this.optKind = res.data.data
            })

            let getWarehouses = this.$axios.get("master/warehouse/selection").then(res => {
                this.optWarehouse = res.data.data.map(it => {
                    return { id: it.id, name: it.name + " - " + it.office_name }
                })
            })

            let getSpecs = this.$axios.get("master/spec/selection").then(res => {
                this.optSpec = res.data.data
            })

            let getColors = this.$axios.get("master/color/selection").then(res => {
                this.optColor = res.data.data
            })

            Promise.all([getKinds, getWarehouses, getSpecs, getColors]).then(res => {
                this.initStatus = 1
            })
                .catch(error => this.initStatus = -1)

        },

        showDetail(item) {
            this.activeItem = item
            this.activeId = item.id
            this.$bvModal.show("m-detail")
        },

        async changeFilter() {

            this.isLoadingTable = true

            await this.getItems()

            // this.filter.noFaktur = ""
            // this.filter.imeiSn = ""

            this.isLoadingTable = false

        },


        getItems(page = 1) {

            this.$bvModal.hide("m-filter")
            this.isBusy = true
            this.items = []
            this.initTable = 1

            if (isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)
            param += this.processFilter()

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("inventory" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listInventoryFilter", JSON.stringify(this.filter))



            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })

        },

        prepareReprint(id) {
            this.activeId = id
            this.$bvModal.show("m-reprint-code")
        },

        getBarcodeLink() {
            if (this.barcodeType == 'barcode') {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`
            }
            else {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLinkDamage}`
            }
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true
            if (this.barcodeType == 'barcode') this.barcodeType = 'damage'
            else this.barcodeType = 'barcode'
            setTimeout(function () {
                this.barcodeToggleCooldown = false
            }.bind(this), 2000);
        },

        getReprintBarcode() {

            this.isSubmitting = true
            let payload = {
                id: this.activeId,
                passcode: this.passcode
            }

            this.$axios.post("inventory/reprint-barcode", payload).then(res => {

                this.barcodeLink = res.data.data.link
                this.barcodeLinkDamage = res.data.data.linkDamage
                this.$bvModal.hide("m-reprint-code")
                this.$bvModal.show("m-reprint-barcode")
                this.passcode = ""

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        isPrintAllowed(item) {
            return ([2, 4, 7].includes(item.status) && !item.is_public) // Hanya READY / RETUR / DRAFT dan bukan item public (ecom)
        },

        downloadExcelStock() {

            this.fetchReportStatus = 0
            this.$bvModal.show("m-download-report")

            let param = this.processFilter()

            this.$axios.get("inventory/excel-stock?" + param).then(res => {

                this.reportPath = res.data.data.path
                this.fetchReportStatus = 1

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.fetchReportStatus = -1
                })
                .finally(() => this.isSubmitting = false)

        },

        isMoveAllowed(item) {
            return [2, 4].includes(item.status) // Hanya READY atau RETUR
        },

        prepareMove(item) {
            this.activeItem = item
            this.$bvModal.show("m-move")
        },

        getBarcodeMoveLink() {
            if (this.barcodeMoveType == 'barcode') {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeMoveLink}`
            }
            else {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeMoveLinkDamage}`
            }
        },

        toggleBarcodeMoveType() {
            this.barcodeToggleCooldown = true
            if (this.barcodeMoveType == 'barcode') this.barcodeMoveType = 'damage'
            else this.barcodeMoveType = 'barcode'
            setTimeout(function () {
                this.barcodeToggleCooldown = false
            }.bind(this), 2000);
        },

        promptMove() {

            let isConfirmed = confirm("Lakukan pemindahan?")
            if (!isConfirmed) return

            if (this.input.warehouse == 0) {
                return this.$helper.toastError(this, "Mohon memilih gudang tujuan!")
            }

            this.isSubmitting = true
            let payload = {
                id: this.activeItem.id,
                warehouse_id: this.input.warehouse
            }

            this.$axios.post("inventory/move-warehouse", payload).then(res => {

                this.$bvModal.hide("m-move")
                this.$helper.toastSuccess(this, "Barang berhasil dipindahkan!")

                let data = res.data.data
                this.activeItem.warehouse = data.name
                this.barcodeMoveLink = data.link
                this.barcodeMoveLinkDamage = data.linkDamage

                this.$bvModal.show("m-barcode")
                this.getItems(this.currentPage)

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        isResetAllowed(item) {
            return ([2, 4].includes(item.status) && !item.is_public) // Hanya READY atau RETUR dan bukan item public (ecom)
        },

        prepareReset(item, type = "") {
            this.activeItem = item
            if (type == "Grade") this.resetType = "Grade"
            else this.resetType = "Inventory"
            this.$bvModal.show("m-request-reset")
        },

        promptReset() {

            if (this.$helper.isBlank(this.resetReason)) {
                return this.$helper.toastError(this, "Mohon mengisi keterangan!")
            }

            let isConfirmed = confirm("Request reset inventory ini kembali ke PENDING?")
            if (!isConfirmed) return

            let payload = {
                id: this.activeItem.id,
                note: this.resetReason,
                type: this.resetType
            }

            this.isSubmitting = true
            this.$axios.post("inventory/request-reset", payload).then(_ => {

                this.$bvModal.hide("m-request-reset")
                this.$helper.toastSuccess(this, "Request berhasil dikirimkan!")
                this.resetReason = ""

                this.getItems(this.currentPage)

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        isAdjustAllowed(item) {
            // return [2, 4, 7].includes(item.status) // Hanya READY, RETUR dan DRAFT
            // return [2, 4].includes(item.status) // Hanya READY dan RETUR
            return [2, 3, 4].includes(item.status) // Hanya READY, SOLD, dan RETUR
        },

        // diubah sementara supaya adjustment harga bisa diinput manual dulu
        // onChangeAdjustmentSelect(item, index){
        //     this.invoiceAdjustments[index].name = item.name
        //     this.invoiceAdjustments[index].adjustment = this.sanitizeString(item.adjustment)
        //     this.invoiceAdjustments[index].adjustmentPercentage = item.adjustment_percentage
        // },

        prepareColorUpdate(item) {
            this.activeItem = item
            this.inputColor = null
            if (item.color_id != null) {
                this.inputColor = {}
                this.inputColor.id = item.color_id
                this.inputColor.name = item.color
            }
            this.$bvModal.show("m-update-color")
        },

        confirmUpdateColor() {
            if (this.inputColor.id == null) {
                return this.$helper.toastError(this, "Warna barang tidak boleh kosong!")
            }

            let payload = {
                id: this.activeItem.id,
                color: this.inputColor.id
            }

            this.isSubmitting = true
            this.$axios.post("inventory/update-color", payload).then(res => {

                this.$helper.toastSuccess(this, "Update warna berhasil dilakukan!")
                this.$bvModal.hide("m-update-color")
                this.activeItem = {}
                this.inputColor = {}
                this.getItems(this.currentPage)

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        prepareAdjustment(item) {
            this.invoiceAdjustments = []
            this.activeItem = item
            this.isSubmitting = true

            // this.$axios.get("adjustment/selection?item_kind_id=" + item.kind_id ).then(res => {

            this.$axios.get("category/selection?item_kind_id=" + this.activeItem.kind_id).then(res => {
                this.optCategory = res.data.data.map(item => {
                    return {
                        value: item.id,
                        text: item.name
                    }
                })

                let param = "?id=" + item.id
                this.$axios.get("inventory/get-invoice-adjustments" + param).then(res => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        if (res.data.data[i].optAdjustments.length > 0) {
                            for (let j = 0; j < res.data.data[i].optAdjustments.length; j++) {
                                if (res.data.data[i].optAdjustments[j].id == res.data.data[i].adjustments_id) {
                                    this.invoiceAdjustments.push({
                                        name_placeholder: res.data.data[i].adjustments_name,
                                        name: res.data.data[i].adjustments_name,
                                        category: res.data.data[i].category_id,
                                        adjustmentSelect: {
                                            id: res.data.data[i].optAdjustments[j].id,
                                            name: res.data.data[i].optAdjustments[j].name,
                                            adjustment: res.data.data[i].optAdjustments[j].adjustment,
                                            adjustment_percentage: res.data.data[i].optAdjustments[j].adjustment_percentage
                                        },
                                        adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                                        adjustmentPercentage: res.data.data[i].adjustment_percentage,
                                        optAdjustments: res.data.data[i].optAdjustments.map(item => {
                                            return {
                                                value: {
                                                    id: item.id,
                                                    name: item.name,
                                                    adjustment: item.adjustment,
                                                    adjustment_percentage: item.adjustment_percentage,
                                                },
                                                text: item.name
                                            }
                                        })
                                    })
                                    break
                                }
                            }
                        }
                        else {
                            this.invoiceAdjustments.push({
                                name_placeholder: res.data.data[i].adjustments_name,
                                name: res.data.data[i].adjustments_name,
                                category: res.data.data[i].category_id,
                                adjustmentSelect: {
                                    id: res.data.data[i].adjustments_id,
                                    name: res.data.data[i].adjustments_name,
                                    adjustment: res.data.data[i].adjustment,
                                    adjustment_percentage: res.data.data[i].adjustment_percentage
                                },
                                adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                                adjustmentPercentage: res.data.data[i].adjustment_percentage,
                                optAdjustments: []
                            })
                        }
                        // diubah sementara supaya adjustment harga bisa diinput manual dulu
                        // this.invoiceAdjustments.push({
                        //     name: res.data.data[i].adjustments_name,
                        //     adjustmentSelect: {
                        //         id: res.data.data[i].adjustments_id,
                        //         name: res.data.data[i].adjustments_name,
                        //         adjustment: res.data.data[i].adjustment,
                        //         adjustment_percentage: res.data.data[i].adjustment_percentage
                        //     },
                        //     adjustment: res.data.data[i].adjustment,
                        //     adjustmentPercentage: res.data.data[i].adjustment_percentage
                        // })
                    }

                    for (var i = 0; i < this.invoiceAdjustments.length; i++) {

                        let adj = this.invoiceAdjustments[i]

                        this.sanitize(adj)

                    }

                    this.$bvModal.show("m-item-to-adjust")
                    this.isChangeAdjustment = false
                })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.isSubmitting = false
                })

        },

        prepareAddAdjustment() {
            this.addAdj.optKind = [
                { value: this.activeItem.kind_id, text: this.activeItem.kind }
            ]
            this.addAdj.kind = this.activeItem.kind_id
            this.addAdj.category = null
            this.addAdj.optAdjustments = []
            this.addAdj.name = null
            if (this.activeItem.fixing_adjustment) {
                this.addAdj.adjustment = "0"
                this.addAdj.adjustmentPercentage = ""
            } else {
                this.addAdj.adjustment = ""
                this.addAdj.adjustmentPercentage = ""
            }
            this.$bvModal.show("m-add-adjustment")
        },

        confirmAddAdjustment() {
            if (this.$helper.isBlank(this.addAdj.name)) {
                this.$helper.toastError(this, "Data Keterangan Adjustment Kerusakan tidak boleh kosong !")
                return
            }

            if (this.$helper.isBlank(this.addAdj.adjustment) && this.$helper.isBlank(this.addAdj.adjustmentPercentage)) {
                if (!this.activeItem.fixing_adjustment) {
                    this.$helper.toastError(this, "Salah satu dari data Adjustment Nominal atau Persentase tidak boleh kosong !")
                    return
                }
            }

            let payload = new FormData()

            payload.append("inventory_id", this.activeItem.id)
            payload.append("adjustment_id", this.addAdj.name)
            if (this.$helper.isBlank(this.addAdj.adjustmentPercentage)) {
                payload.append("adjustment", this.$helper.toNumber(this.addAdj.adjustment))
            }
            else {
                payload.append("adjustment", parseInt(this.activeItem.final_price * parseFloat(this.addAdj.adjustmentPercentage.replace(',', '.').replace(' ', '')) / 100))
                payload.append("adjustment_percentage", Number(parseFloat(this.addAdj.adjustmentPercentage.replace(',', '.').replace(' ', ''))).toFixed(2))
            }

            this.isSubmitting = true
            this.$axios.post("inventory/add-invoice-adjustments", payload).then(res => {

                let param = "?id=" + this.activeItem.id
                this.$axios.get("inventory/get-latest-invoice-adjustment" + param).then(res => {
                    //                    this.invoiceAdjustments = []
                    for (let i = 0; i < res.data.data.length; i++) {
                        if (res.data.data[i].optAdjustments.length > 0) {
                            for (let j = 0; j < res.data.data[i].optAdjustments.length; j++) {
                                if (res.data.data[i].optAdjustments[j].id == res.data.data[i].adjustments_id) {
                                    this.invoiceAdjustments.push({
                                        name: res.data.data[i].adjustments_name,
                                        category: res.data.data[i].category_id,
                                        adjustmentSelect: {
                                            id: res.data.data[i].optAdjustments[j].id,
                                            name: res.data.data[i].optAdjustments[j].name,
                                            adjustment: res.data.data[i].optAdjustments[j].adjustment,
                                            adjustment_percentage: res.data.data[i].optAdjustments[j].adjustment_percentage
                                        },
                                        adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                                        adjustmentPercentage: res.data.data[i].adjustment_percentage,
                                        optAdjustments: res.data.data[i].optAdjustments.map(item => {
                                            return {
                                                value: {
                                                    id: item.id,
                                                    name: item.name,
                                                    adjustment: item.adjustment,
                                                    adjustment_percentage: item.adjustment_percentage,
                                                },
                                                text: item.name
                                            }
                                        })
                                    })
                                    break
                                }
                            }
                        }
                        else {
                            this.invoiceAdjustments.push({
                                name: res.data.data[i].adjustments_name,
                                category: res.data.data[i].category_id,
                                adjustmentSelect: {
                                    id: res.data.data[i].adjustments_id,
                                    name: res.data.data[i].adjustments_name,
                                    adjustment: res.data.data[i].adjustment,
                                    adjustment_percentage: res.data.data[i].adjustment_percentage
                                },
                                adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                                adjustmentPercentage: res.data.data[i].adjustment_percentage,
                                optAdjustments: []
                            })
                        }
                        // diubah sementara supaya adjustment harga bisa diinput manual dulu
                        // this.invoiceAdjustments.push({
                        //     name: res.data.data[i].adjustments_name,
                        //     adjustmentSelect: {
                        //         id: res.data.data[i].adjustments_id,
                        //         name: res.data.data[i].adjustments_name,
                        //         adjustment: res.data.data[i].adjustment,
                        //         adjustment_percentage: res.data.data[i].adjustment_percentage
                        //     },
                        //     adjustment: res.data.data[i].adjustment,
                        //     adjustmentPercentage: res.data.data[i].adjustment_percentage
                        // })
                    }

                    for (var i = 0; i < this.invoiceAdjustments.length; i++) {

                        let adj = this.invoiceAdjustments[i]

                        this.sanitize(adj)

                    }

                    this.$bvModal.hide("m-add-adjustment")
                    this.isChangeAdjustment = true
                })
                    // this.$axios.get("inventory/get-invoice-adjustments" + param).then(res => {
                    //     this.invoiceAdjustments = []
                    //     for(let i = 0; i < res.data.data.length; i++){
                    //         for(let j = 0; j < res.data.data[i].optAdjustments.length; j++){
                    //             if(res.data.data[i].optAdjustments[j].id == res.data.data[i].adjustments_id){
                    //                 this.invoiceAdjustments.push({
                    //                     name: res.data.data[i].adjustments_name,
                    //                     category: res.data.data[i].category_id,
                    //                     adjustmentSelect: {
                    //                         id: res.data.data[i].optAdjustments[j].id,
                    //                         name: res.data.data[i].optAdjustments[j].name,
                    //                         adjustment: res.data.data[i].optAdjustments[j].adjustment,
                    //                         adjustment_percentage: res.data.data[i].optAdjustments[j].adjustment_percentage
                    //                     },
                    //                     adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                    //                     adjustmentPercentage: res.data.data[i].adjustment_percentage,
                    //                     optAdjustments: res.data.data[i].optAdjustments.map(item => {
                    //                         return {
                    //                             value: {
                    //                                 id: item.id,
                    //                                 name: item.name,
                    //                                 adjustment: item.adjustment,
                    //                                 adjustment_percentage: item.adjustment_percentage,
                    //                             },
                    //                             text: item.name
                    //                         }
                    //                     })
                    //                 })
                    //                 break
                    //             }
                    //         }
                    //     }

                    //     for(var i = 0; i < this.invoiceAdjustments.length; i++) {

                    //         let adj = this.invoiceAdjustments[i]

                    //         this.sanitize(adj)

                    //     }

                    //     this.$bvModal.hide("m-add-adjustment")
                    // })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.isSubmitting = false
                })
        },

        onChangeRowCategory(index) {
            this.invoiceAdjustments[index].name = ""
            this.invoiceAdjustments[index].adjustmentSelect = null
            this.invoiceAdjustments[index].optAdjustments = []
            if (!this.$helper.isBlank(this.invoiceAdjustments[index].category)) {
                let param = "?item_kind_id=" + this.activeItem.kind_id
                param += "&category_id=" + this.invoiceAdjustments[index].category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.invoiceAdjustments[index].optAdjustments = res.data.data.map(item => {
                        return {
                            value: {
                                id: item.id,
                                name: item.name,
                                adjustment: item.adjustment,
                                adjustment_percentage: item.adjustment_percentage,
                            },
                            text: item.name
                        }
                    })
                    this.isSubmitting = false
                })
            }
            this.isChangeAdjustment = true
        },

        changeAdjustment() {
            this.isChangeAdjustment = true
        },

        onChangeAdjCategory() {
            this.addAdj.name = null
            this.addAdj.optAdjustments = []
            if (!this.$helper.isBlank(this.addAdj.category)) {
                let param = "?item_kind_id=" + this.activeItem.kind_id
                param += "&category_id=" + this.addAdj.category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.addAdj.optAdjustments = res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    })
                    this.isSubmitting = false
                })
            }
        },

        // addRow() {
        //     this.invoiceAdjustments.push({ name: "", adjustmentSelect: "", adjustment: "", adjustmentPercentage: "" })
        // },

        deleteRow(index) {
            this.invoiceAdjustments.splice(index, 1)
            this.isChangeAdjustment = true
        },

        confirmAdd(id) {

            let confirmable = true

            for (var i = 0; i < this.invoiceAdjustments.length; i++) {

                let adj = this.invoiceAdjustments[i]

                if (this.$helper.isBlank(adj.adjustmentSelect) || (this.$helper.isBlank(adj.adjustment) && this.$helper.isBlank(adj.adjustmentPercentage)) || this.$helper.isBlank(adj.adjustmentSelect.id)) {
                    confirmable = false
                    return this.$helper.toastError(this, "Terdapat data adjustment yang kosong, mohon dilengkapi!")
                }

            }

            if (confirmable) {
                let payload = new FormData()
                let jsonData = {
                    adjInvoice: this.invoiceAdjustments.map(it => {
                        if (this.$helper.isBlank(it.adjustmentPercentage)) {
                            return {
                                name: it.adjustmentSelect.name,
                                adjustment: this.$helper.toNumber(it.adjustment),
                                adjustmentPercentage: null,
                                adjustment_id: it.adjustmentSelect.id
                            }
                        }
                        else {
                            return {
                                name: it.adjustmentSelect.name,
                                adjustment: parseInt(this.activeItem.final_price * parseFloat(it.adjustmentPercentage.replace(',', '.').replace(' ', '')) / 100),
                                adjustmentPercentage: Number(parseFloat(it.adjustmentPercentage.replace(',', '.').replace(' ', ''))).toFixed(2),
                                adjustment_id: it.adjustmentSelect.id
                            }
                        }
                    })
                }

                payload.append("data", JSON.stringify(jsonData))
                payload.append("id", id)
                payload.append("changed", this.isChangeAdjustment)

                this.isSubmitting = true
                this.$axios.post("inventory/update-invoice-adjustments", payload).then(res => {
                    this.$helper.toastSuccess(this, "Update Adjustment Berhasil!")
                    this.$bvModal.hide("m-item-to-adjust")
                    this.getItems(this.currentPage)
                })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)
            }

        },

        sanitize(item) {

            let cleaned = String(item.adjustment).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            item.adjustment = res
            this.isChangeAdjustment = true

        },

        sanitizeString(str) {
            let cleaned = String(str).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            return res
        },

        prepareImage(item, type) {
            this.mediaPreview = {}
            this.mediaList = []
            this.prepareImageType = type
            this.activeItem = item
            this.isSubmitting = true
            let param = "?id=" + item.id
            if (type == 'kerusakan') {
                this.$axios.get("inventory-damaged-photo" + param).then(res => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        let fileMedia = ''
                        let fileAltText = ''
                        if (res.data.data[i].type == 'image/jpeg' || res.data.data[i].type == 'image/png') {
                            fileMedia = 'image'
                            fileAltText = 'Upload Image Preview'
                        }
                        else if (res.data.data[i].type == 'video/mp4' || res.data.data[i].type == 'video/webm' || res.data.data[i].type == 'video/ogg' || res.data.data[i].type == 'video/3gpp') {
                            fileMedia = 'video'
                            fileAltText = 'Upload Video Preview'
                        }
                        else {
                            continue
                        }
                        let filenameSplit = res.data.data[i].path.split('/')
                        filenameSplit = filenameSplit[filenameSplit.length - 1].split('.')
                        let fileExtension = filenameSplit.pop()
                        let filename = filenameSplit.join()
                        this.mediaList.push({
                            id: res.data.data[i].id,
                            media: fileMedia,
                            type: res.data.data[i].type,
                            filename: filename,
                            extension: fileExtension,
                            url: res.data.data[i].path,
                            altText: fileAltText,
                            status: 'get',
                            isActive: false,
                            file: null
                        })
                    }
                    this.isImageChanged = false
                    this.$bvModal.show("m-image-old")
                })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)
            } else if (type == 'fisik') {
                this.$axios.get("inventory-photo" + param).then(res => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        let fileMedia = 'image'
                        let fileAltText = 'Upload Image Preview'
                        let filenameSplit = res.data.data[i].path.split('/')
                        filenameSplit = filenameSplit[filenameSplit.length - 1].split('.')
                        let fileExtension = filenameSplit.pop()
                        let filename = filenameSplit.join()
                        let fileType = ""

                        if (fileExtension == 'jpg' || fileExtension == 'jpeg' || fileExtension == 'png') {
                            fileMedia = 'image'
                            fileType = `image/${fileExtension}`
                            fileAltText = 'Upload Image Preview'

                        } else if (fileExtension == 'mp4' || fileExtension == 'webm' || fileExtension == 'ogg' || fileExtension == '3gpp') {
                            fileMedia = 'video'
                            fileType = `video/${fileExtension}`
                            fileAltText = 'Upload Video Preview'
                        } else {
                            continue
                        }


                        this.mediaList.push({
                            id: res.data.data[i].id,
                            media: fileMedia,
                            type: fileType,
                            filename: filename,
                            extension: fileExtension,
                            url: res.data.data[i].path,
                            urlCompress: this.modifyPathCompress(res.data.data[i].path_compress),
                            title: res.data.data[i].category.name || '-',
                            altText: fileAltText,
                            status: 'get',
                            isActive: false,
                            file: null
                        })
                    }
                    this.isImageChanged = false
                    this.$bvModal.show("m-image-old")
                })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)
            }
        },

        prepareAdjImage(item) {
            this.activeAdjustmentRow = item
            this.mediaPreview = {}
            this.mediaList = []
            this.activeAdjustment = item.adjustmentSelect
            this.isSubmitting = true
            let param = "?inventory_id=" + this.activeItem.id
            param += "&adjustment_id=" + this.activeAdjustment.id
            this.$axios.get("adjustment-damaged-photo" + param).then(res => {
                for (let i = 0; i < res.data.data.length; i++) {
                    let fileMedia = ''
                    let fileAltText = ''
                    if (res.data.data[i].type == 'image/jpeg' || res.data.data[i].type == 'image/png') {
                        fileMedia = 'image'
                        fileAltText = 'Upload Image Preview'
                    }
                    else if (res.data.data[i].type == 'video/mp4' || res.data.data[i].type == 'video/webm' || res.data.data[i].type == 'video/ogg' || res.data.data[i].type == 'video/3gpp') {
                        fileMedia = 'video'
                        fileAltText = 'Upload Video Preview'
                    }
                    else {
                        continue
                    }
                    let filenameSplit = res.data.data[i].path.split('/')
                    filenameSplit = filenameSplit[filenameSplit.length - 1].split('.')
                    let fileExtension = filenameSplit.pop()
                    let filename = filenameSplit.join()
                    this.mediaList.push({
                        id: res.data.data[i].id,
                        media: fileMedia,
                        type: res.data.data[i].type,
                        filename: filename,
                        extension: fileExtension,
                        title: (res.data.data[i].category) ? res.data.data[i].category.name : '-',
                        url: res.data.data[i].path,
                        urlCompress: this.modifyPathCompress(res.data.data[i].path_compress),
                        altText: fileAltText,
                        status: 'get',
                        isActive: false,
                        file: null
                    })
                }
                this.isImageChanged = false
                this.$bvModal.show("m-image")

                setTimeout(() => {
                    this.initResumable()
                }, 1000)
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        onClickImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                this.mediaList[i].isActive = false
                if (this.mediaList[i].urlCompress == url) {
                    this.mediaList[i].isActive = true
                    this.mediaPreview = lodash.cloneDeep(this.mediaList[i])
                }
            }
        },

        onAddImage() {
            this.$refs.fileupload.click()
            this.isChangePhotoAdjustment = true
        },

        onUploadImage(e) {
            var files = e.target.files || e.dataTransfer.files
            if (!files.length) return
            // else if(files[0].size > this.$uploadLimit) {
            //     return
            // }
            if (this.filterMediaList.length + files.length > 10) {
                this.$helper.toastError(this, "Operasi Upload Dibatalkan! Jumlah gambar / video melebihi kapasitas maksimal 10 item per inventori.")
                return
            }
            for (let i = 0; i < files.length; i++) {
                let fileMedia = ''
                let fileAltText = ''
                if (files[i].type == 'image/jpeg' || files[i].type == 'image/png') {
                    fileMedia = 'image'
                    fileAltText = 'Upload Image Preview'
                }
                else if (files[i].type == 'video/mp4' || files[i].type == 'video/webm' || files[i].type == 'video/ogg') {
                    fileMedia = 'video'
                    fileAltText = 'Upload Video Preview'
                }
                else {
                    this.$helper.toastError(this, "Upload Item Gagal! Jenis file " + files[i].name + " tidak dikenali oleh sistem.")
                    continue
                }
                let filenameSplit = files[i].name.split('.')
                let fileExtension = filenameSplit.pop()
                let filename = filenameSplit.join()
                let fileResult = {
                    id: null,
                    media: fileMedia,
                    type: files[i].type,
                    filename: filename,
                    extension: fileExtension,
                    url: URL.createObjectURL(files[i]),
                    altText: fileAltText,
                    status: 'upload',
                    isActive: false,
                    file: files[i]
                }
                this.mediaList.push(fileResult)
                // for(let i = 0; i < this.mediaList.length; i++){
                //     this.mediaList[i].isActive = false
                // }
                // this.mediaPreview = lodash.cloneDeep(fileResult)
                this.isImageChanged = true
                this.$helper.toastSuccess(this, "Upload " + files[i].name + " berhasil!")
            }
            this.$refs.fileupload.value = null
        },

        onOpenImage(url) {
            window.open(this.$BASE_FILE_PATH + url, '_blank')
        },

        onDeleteImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                if (this.mediaList[i].url == url) {
                    if (this.mediaList[i].status == 'get') {
                        this.mediaList[i].status = 'delete'


                        let payload = new FormData()

                        payload.append("inventory_id", this.activeItem.id)
                        payload.append("id_photo", this.mediaList[i].id)

                        this.$axios.post("adjustment-damaged-photo/delete", payload).then(_ => {
                            this.$helper.toastSuccess(this, "Hapus Gambar Berhasil!")
                            // this.$bvModal.hide("m-image")
                            if (this.isChangePhotoAdjustment) {
                                this.isChangeAdjustment = true
                            }

                        })
                            .catch(error => this.$helper.parseError(this, error))
                    }
                    else {
                        this.mediaList.splice(i, 1)
                    }
                    this.isImageChanged = true
                    break
                }
            }
            this.mediaPreview = {}
            this.isChangePhotoAdjustment = true
        },

        // onSaveImage(id) {
        onSaveImage() {

            // if(this.filterMediaList.length < 1 && this.filterMediaList.length != 0){
            //     this.$helper.toastError(this, "Operasi Save Dibatalkan! Jumlah gambar / video kurang dari batas minimal 1 item per inventori.")
            //     return
            // }

            if (this.filterMediaList.length > 10) {
                this.$helper.toastError(this, "Operasi Save Dibatalkan! Jumlah gambar / video melebihi kapasitas maksimal 10 item per inventori.")
                return
            }

            this.isSubmitting = true

            let payload = new FormData()

            let uploadData = this.mediaList.filter(item => item.status == 'upload')
            let deleteData = this.mediaList.filter(item => item.status == 'delete')

            let totalSize = 0

            for (let i = 0; i < this.fileUploadResumable.length; i++) {
                totalSize += this.fileUploadResumable[i].file.size
                if (totalSize > 419430400) {
                    this.$helper.toastError(this, "Operasi Save Dibatalkan! Total ukuran gambar / video melebihi kapasitas maksimal 400MB untuk sekali upload.")
                    return
                }
                payload.append("url[]", this.fileUploadResumable[i].url)
                payload.append("fileName[]", this.fileUploadResumable[i].fileNameUrl)
            }

            for (let i = 0; i < deleteData.length; i++) {
                payload.append("deletes[]", deleteData[i].id)
            }

            payload.append("inventory_id", this.activeItem.id)
            payload.append("adjustment_id", this.activeAdjustment.id)

            this.$axios.post("adjustment-damaged-photo/update", payload).then(_ => {

                this.$helper.toastSuccess(this, "Update Gambar Berhasil!")
                this.$bvModal.hide("m-image")
                if (this.isChangePhotoAdjustment) {
                    this.isChangeAdjustment = true
                }

            })
                .catch(error => {
                    this.$helper.toastError(this, "Operasi Save Gagal! mohon dicoba kembali.")
                    this.$bvModal.hide("m-image")
                    this.initResumable()
                })
                .finally(() => {
                    this.isSubmitting = false
                    this.finalizeBroken = false
                })

        },

        onSaveImageFisik(id) {

            if (this.filterMediaList.length > 10) {
                this.$helper.toastError(this, "Operasi Save Dibatalkan! Jumlah gambar melebihi kapasitas maksimal 10 item per inventori.")
                return
            }

            this.isSubmitting = true

            let payload = new FormData()

            let uploadData = this.mediaList.filter(item => item.status == 'upload')
            let deleteData = this.mediaList.filter(item => item.status == 'delete')

            let totalSize = 0

            for (let i = 0; i < uploadData.length; i++) {
                totalSize += uploadData[i].file.size
                if (totalSize > 419430400) {
                    this.$helper.toastError(this, "Operasi Save Dibatalkan! Total ukuran gambar melebihi kapasitas maksimal 400MB untuk sekali upload.")
                    return
                }
                payload.append("uploads[]", uploadData[i].file)
            }

            for (let i = 0; i < deleteData.length; i++) {
                payload.append("deletes[]", deleteData[i].id)
            }

            payload.append("inventory_id", this.activeItem.id)

            this.$axios.post("inventory-photo/update", payload).then(_ => {

                this.$helper.toastSuccess(this, "Update Gambar Fisik Berhasil!")
                this.$bvModal.hide("m-image-old")
                // if(this.isChangePhotoAdjustment){
                //     this.isChangeAdjustment = true
                // }

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        onCloseModalImage(e) {
            // if (this.isImageChanged) {
            //     let isConfirmed = confirm("Apakah anda yakin ingin menutup menu Gambar Kerusakan? Perubahan yang belum disimpan akan hilang.")
            //     if (!isConfirmed) e.preventDefault()
            // }
        },

        onCloseModalAdjustment(e) {
            let isConfirmed = confirm("Apakah anda yakin ingin menutup menu Adjustment Barang? Perubahan yang belum disimpan akan hilang.")
            if (!isConfirmed) e.preventDefault()
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        parseStatus(status, index) {
            switch (status) {
                case 2: return ["dark", "READY"][index]
                case 3: return ["success", "TERJUAL"][index]
                case 4: return ["warning", "RETUR"][index]
                case 5: return ["danger", "HILANG"][index]
                case 6: return ["primary", "KIRIM BALIK PGI"][index]
                case 66: return ["primary", "REQUEST KIRIM BALIK PGI"][index]
                case 7: return ["light", "DRAFT"][index]
                case 55: return ["dark", "REQUEST HILANG"][index]
                case 8: return ["dark", "REQUEST RESET"][index]
                default: return ["light", "-"][index]
            }
        },

        resetFilter() {

            this.filter = {
                name: "",
                kind: null,
                brand: null,
                itemYear: "",
                spec: null,
                warehouse: null,
                noFaktur: "",
                imeiSn: "",
                grade: [],
                isBatangan: -1,
                status: [],
                from: null,
                to: null
            }

            this.getItems()

        },

        processFilter() {

            let param = ""

            if (!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name
            }

            if (this.filter.kind != null) {
                param += "&filterKind=" + this.filter.kind.id
            }

            if (this.filter.brand != null) {
                param += "&filterBrand=" + this.filter.brand.id
            }

            if (!this.$helper.isBlank(this.filter.itemYear) && !isNaN(this.filter.itemYear)) {
                param += "&filterItemYear=" + Number(this.filter.itemYear)
            }

            if (!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur
            }

            if (!this.$helper.isBlank(this.filter.imeiSn)) {
                param += "&filterImeiSn=" + this.filter.imeiSn
            }

            if (this.filter.status.length != 0) {
                param += "&filterStatus=" + this.filter.status.map(it => it.id).join()
            }

            if (this.filter.grade.length != 0) {
                param += "&filterGrade=" + this.filter.grade.map(it => it.id).join()
            }

            if (this.filter.isBatangan != -1) {
                param += "&filterIsBatangan=" + this.filter.isBatangan
            }

            if (this.filter.warehouse != null) {
                param += "&filterWarehouse=" + this.filter.warehouse.id
            }

            if (this.filter.spec != null) {
                param += "&filterSpec=" + this.filter.spec.id
            }

            if (this.filter.from != null) {
                param += "&filterFrom=" + this.filter.from
            }

            if (this.filter.to != null) {
                param += "&filterTo=" + this.filter.to
            }

            return param

        },

        showModalFilter() {
            this.$bvModal.show("m-filter")
        },

        modifyPathCompress(path) {
            if (/\/storage\//.test(path)) {
                return path;
            } else {
                return `/storage/${path}`;
            }
        },
        // finds the file in the local files array
        findFile(file) {
            return this.fileUploadResumable.find(item => item.uniqueIdentifier === file.uniqueIdentifier && item.status !== 'canceled') || {}
        },
        initResumable() {

            // init resumablejs on mount
            this.resumable = new Resumable({
                target: this.$BASE_UPLOAD_PATH,
                fileType: ['mp4', 'mov', 'png', 'jpg', 'jpeg'],
                chunkSize: 1 * 1024 * 1024, // default is 1*1024*1024, this should be less than your maximum limit in php.ini
                headers: {
                    'Accept': 'application/json'
                },
                query: {
                    feature: "adjdmgpht",
                },
                testChunks: false,
                throttleProgressCallbacks: 1,
                chunkRetryInterval: 5000,
            });

            // Resumable.js isn't supported, fall back on a different method
            if (!this.resumable.support) return alert('Your browser doesn\'t support chunked uploads. Get a better browser.');

            this.resumable.assignBrowse(document.getElementById('uploadFile'));
            this.resumable.assignDrop(document.getElementById('uploadFile'));

            let that = this

            // set up event listeners to feed into vues reactivity
            this.resumable.on('fileAdded', (file, event) => {
                file.hasUploaded = false
                this.isUpload = true

                that.fileUploadResumable.push({
                    file: file,
                    fileName: file.fileName,
                    uniqueIdentifier: file.uniqueIdentifier || "",
                    status: 'uploading',
                    progress: 0,
                    url: "",
                    fileNameUrl: ""
                })

                this.resumable.upload()

                this.uploadKey += 1
            })

            this.resumable.on('complete', () => {
                this.finalizeBroken = true
                this.onSaveImage()
                this.isUpload = false
                that.fileUploadResumable = []
            })

            this.resumable.on('fileSuccess', (file, event) => {
                let response = JSON.parse(event)

                this.findFile(file).status = 'success'
                this.findFile(file).url = response.data.path || ""
                this.findFile(file).fileNameUrl = response.data.filename || ""

                this.uploadKey += 1
            })
            this.resumable.on('fileError', (file) => {
                this.findFile(file).status = 'error'
                this.uploadKey += 1
            })
            this.resumable.on('fileRetry', (file) => {
                this.findFile(file).status = 'retry'
                this.uploadKey += 1
            })
            this.resumable.on('fileProgress', (file) => {

                const fileUpload = this.findFile(file)

                if (fileUpload.status !== 'canceled') {
                    fileUpload.status = 'uploading'
                    fileUpload.progress = Math.floor(file.progress() * 100)
                }

                this.uploadKey += 1

            })
        },

        onRefreshImage() {
            this.prepareAdjImage(this.activeAdjustmentRow)
        },

        copyToClipboard(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.$helper.toastSuccess(this, "Berhasil menyalin teks ke clipboard!")
            }, () => {
                this.$helper.toastError(this, "Gagal menyalin teks ke clipboard!")
            })
        }
    },
    computed: {
        filterMediaList() {
            return this.mediaList.filter(item => item.status != 'delete')
        }
    },
    created() {
        // if (!this.$helper.isBlank(sessionStorage.getItem("listInventoryFilter"))) {
        //     this.filter = JSON.parse(sessionStorage.getItem("listInventoryFilter"))
        // }
        this.init()
        this.isDownloadExcelAllowed = this.$helper.isAllowed(this.$helper.PERM_DOWNLOAD_EXCEL_STOCK)
        this.isMoveInventoryAllowed = this.$helper.isAllowed(this.$helper.PERM_MOVE_INVENTORY)
        this.isRequestResetAllowed = this.$helper.isAllowed(this.$helper.PERM_REQUEST_RESET_INVENTORY)
    }
}
</script>

<style scoped>
/deep/ .adjust-column-min {
    min-width: 200px;
}

.media-container {
    height: 0;
    padding-top: 56.25%;
    position: relative;
}

.media-preview {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    left: 50%;
    transform: translateX(-50%);
}

:not(:root):-webkit-full-screen {
    object-fit: contain !important;
}

.media-scroll {
    margin-top: 10px;
    height: 70px;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    background-color: #dee2e6;
    white-space: nowrap;
}

.media-scroll-content {
    display: inline-block !important;
    height: 100%;
    width: 20%;
}

.media-scroll-preview.active {
    border: 5px solid #65c2e4;
}

.media-scroll-preview:hover {
    opacity: 0.5;
}

.media-scroll-preview {
    height: 100%;
    width: 100%;
    border: 5px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    cursor: pointer;
}

.border-responsive {
    margin-top: 10px;
    border-top: 1px solid #c8ced3;
}

.media-disclaimer {
    text-align: justify;
    text-justify: inter-word;
}

@media only screen and (min-width: 576px) {
    .media-scroll {
        height: 100px;
    }
}

@media only screen and (min-width: 992px) {
    .border-responsive {
        margin-top: 0px;
        border-top: none;
        border-left: 1px solid #c8ced3;
    }
}

@media only screen and (min-width: 1200px) {
    .media-scroll {
        height: 150px;
    }
}
</style>
